import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'filters',
    path: 'stages',
    viewPath: props.viewPath,
  })

  let stage = useDataValue({
    context: 'stage',
    viewPath: props.viewPath,
  })

  let stages = useDataValue({
    context: 'filters',
    path: 'stages',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let shouldRemove = stages.some(({ id }) => id === stage.id)
    change([
      ...stages.filter(({ id }) => id !== stage.id),
      ...(shouldRemove ? [] : [stage]),
    ])
  }
}

export function isChecked(stages, stageId) {
  return stages.some(({ id }) => id === stageId)
}

export function boardName(stages, stage) {
  let boards = [...new Set(stages?.map(stage => stage.board.id))]

  return boards?.length > 1 && `(${stage.board.name})`
}
